export const MODAL_NAME = {
  ADD_CARD_TO_PAGE: 'ADD_CARD_TO_PAGE',
  ADD_TO_TRADELIST: 'ADD_TO_TRADELIST',
  ADDRESS_CREATE: 'ADDRESS_CREATE',
  ADDRESS_LIST: 'ADDRESS_LIST',
  ALERT: 'ALERT',
  APPLY_FOILER_RESULT: 'APPLY_FOILER_RESULT',
  APPLY_FOILER: 'APPLY_FOILER',
  BANK_ACCOUNT_CREATE: 'BANK_ACCOUNT_CREATE',
  BUY_OFFER: 'BUY_OFFER',
  CLOSE_EVENT: 'CLOSE_EVENT',
  CLOSE_TUMULT_EVENT: 'CLOSE_TUMULT_EVENT',
  CMS_MODAL: 'CMS_MODAL',
  CONFIRM_DECK_DELETION: 'CONFIRM_DECK_DELETION',
  CONFIRM_MODAL: 'CONFIRM_MODAL',
  CONFIRM_OFFER_DELETION: 'CONFIRM_OFFER_DELETION',
  CONFIRM_UNSUBSUCRIBE: 'CONFIRM_UNSUBSUCRIBE',
  CREATE_PAYMENT: 'CREATE_PAYMENT',
  CREATE_PRINTING_ORDER: 'CREATE_PRINTING_ORDER',
  CREATE_PRINTING_PAGE: 'CREATE_PRINTING_PAGE',
  CREATE_TEAM_MEMBER: 'CREATE_TEAM_MEMBER',
  DECK_CHANGE_HERO: 'DECK_CHANGE_HERO',
  DECK_FILTER: 'DECK_FILTER',
  DECK_LEGAL_DETAIL: 'DECK_LEGAL_DETAIL',
  DECK_RENAME: 'DECK_RENAME',
  DECK_STATS: 'DECK_STATS',
  DELETE_SHOP: 'DELETE_SHOP',
  DUPLICATE_DECK: 'DUPLICATE_DECK',
  EDITORIAL_NAV: 'EDITORIAL_NAV',
  EVENT_ADMIN_ADD_USER: 'EVENT_ADMIN_ADD_USER',
  FILTERS: 'FILTERS',
  FRIENDS_LIST: 'FRIENDS_LIST',
  GIVE_CARD: 'GIVE_CARD',
  LANGUAGE: 'LANGUAGE',
  MANAGE_OFFER: 'MANAGE_OFFER',
  MANAGE_POD_ENTRANT: 'MANAGE_POD_ENTRANT',
  PAYMENT_LIST: 'PAYMENT_LIST',
  PAYMENT_SUMMARY: 'PAYMENT_SUMMARY',
  PAYMENT_TYPE_LIST: 'PAYMENT_TYPE_LIST',
  PAYOUT_MODAL: 'PAYOUT_MODAL',
  PICK_AVATAR: 'PICK_AVATAR',
  PICK_BACKGROUND: 'PICK_BACKGROUND',
  PICK_COLLECTIONS_CARDS: 'PICK_COLLECTIONS_CARDS',
  PRICING_OFFERS: 'PRICING_OFFERS',
  PRINTING_CARD_LIST: 'PRINTING_CARD_LIST',
  PRINTING_STATUS: 'PRINTING_STATUS',
  RELOAD_WALLET: 'RELOAD_WALLET',
  RENAME_PRINTING_PAGE: 'RENAME_PRINTING_PAGE',
  SEASON_PASS_FACTION: 'SEASON_PASS_FACTION',
  SEASON_PASS_REWARDS: 'SEASON_PASS_REWARDS',
  SHARE_DECK: 'SHARE_DECK',
  SHARE_PRINTING_ORDER: 'SHARE_PRINTING_ORDER',
  SHOP_DETAILS: 'SHOP_DETAILS',
  SHOP_EVENTS_LIST: 'SHOP_EVENTS_LIST',
  TRADE_CARD_LIST: 'TRADE_CARD_LIST',
  USER_NAV: 'USER_NAV',
  ZOOM_SLIDER: 'ZOOM_SLIDER',
  ZOOM: 'ZOOM',
} as const;
